import { Action } from '../../../common/actions/core/action';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../../common/actions/core/action-handler';
import StorageService from '../../services/storage.service';
import { OtpExpireAction } from './otp-expire-dialog.action';

/* @ngInject */
export default class OtpExpireDialogController implements ActionHandler {
    private dialogElement;

  constructor(
    private $element,
    private $window,
    private storageService: StorageService,
    private actionDispatcher: ActionDispatcherService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#otp-expire-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OtpExpireAction) {
      this.openDialog();
    }
  }

  public onClick() {
    this.dialogElement.close();
    this.storageService.removeMsisdn();
    this.$window.scrollTo(0, 0);
    window.location.reload();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
    this.dialogElement.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/otp-expire-dialog/otp-expire-dialog.controller.ts